import React from 'react';
import { UseFormRegister, Path } from 'react-hook-form';

interface CheckboxProps<T extends Record<string, unknown>> extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type'
> {
  name?: Path<T>;
  register?: UseFormRegister<T>;
}

export function Checkbox<T extends Record<string, unknown>>({
  name,
  register,
  className = 'checked:bg-brand',
  ...props
}: CheckboxProps<T>) {
  return (
    <div className="flex">
      <input
        type="checkbox"
        id={name}
        className={`peer relative size-4 shrink-0 cursor-pointer appearance-none border-2 border-line transition-all checked:border-0 checked:bg-brandOrange ${className} `}
        {...props}
        {...(name && register
          ? register(name, { onChange: props.onChange })
          : {})}
      />
      <svg
        className="pointer-events-none absolute hidden size-4 peer-checked:block"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </div>
  );
}
